import { updateAssetQuery } from '../mutations';
import makeRequest from '../../../../common/utils/makeRequest';







export default async function updateAsset(
apiClient,
assetId,
input)
{
  const requestParams = {
    mutation: updateAssetQuery,
    variables: { assetId, input },
    context: { module: 'assets' }
  };
  const { data, error } = await makeRequest({ request: apiClient.mutate, requestParams });

  if (!data || !data.updateAsset || error) {return null;}

  return data.updateAsset;
}